import React, { useEffect, useState } from "react";
import { Tabs, TabList, Tab, TabPanel } from "react-tabs";
import { Helmet } from "react-helmet";
import jwt_decode from "jwt-decode";

// import Custom Components
import Breadcrumb from "../../common/breadcrumb";
import HandleLogin from "../../../handlers/HandleLogin";
import HandleSignup from "../../../handlers/HandleSigup";
import { toast } from "react-toastify";
import validateToken from "../../../utils/TokenValidator";
import Loader from "../../common/loader";

function LoginOne() {
  const [loading, setloading] = useState(false);

  const [loginForm, setLoginForm] = useState({
    email: "",
    password: "",
    name: "",
    username: "",
    userType: "CUSTOMER",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLoginForm({
      ...loginForm,
      [name]: value,
    });
  };

  useEffect(() => {
    const handleScrollToTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };
    handleScrollToTop();
    // Get the token from the URL query parameters
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    if (token) {
      // Save the token to localStorage
      localStorage.setItem("Token", token);
      const decodedToken = jwt_decode(token);
      localStorage.setItem("name", decodedToken.name);
      localStorage.setItem("Username", decodedToken.username);
      localStorage.setItem("Email", decodedToken.email);
      localStorage.setItem("UserType", decodedToken.userType);
      toast.success("Login Sucess");
      setTimeout(() => {
        window.location.href = "/";
      }, 2000);
    } else {
      const { valid, expired } = validateToken();
      if (valid === true && expired === false) {
        window.location.href = "/";
      }
    }
    // Redirect to another page or perform any other actions
    // history.push("/dashboard");
  }, []);

  const OnLogin = (e) => {
    e.preventDefault();
    setloading(true);
    HandleLogin(loginForm.email, loginForm.password);
    setloading(false);
  };

  const OnSignup = (e) => {
    e.preventDefault();
    setloading(true);
    HandleSignup(loginForm);
    setloading(false);
  };

  return (
    <div className="main">
      {loading && <Loader />}

      <Helmet>
        <title>LIBER - Signin/Register </title>
      </Helmet>

      <h1 className="d-none">LIBER - Signin/Register</h1>

      <Breadcrumb
        title="Login"
        parent1={["pages", "pages/about"]}
        adClass="border-0 mb-0"
      />

      <div
        className="login-page bg-image pt-8 pb-8 pt-md-12 pb-md-12 pt-lg-17 pb-lg-17"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/backgrounds/login-bg.jpg)`,
        }}
      >
        <div className="container">
          <div className="form-box">
            <div className="form-tab">
              <Tabs selectedTabClassName="show" defaultIndex={0}>
                <TabList
                  className="nav nav-pills nav-fill"
                >
                  <Tab className="nav-item">
                    <span className="nav-link">Sign In</span>
                  </Tab>

                  <Tab className="nav-item">
                    <span className="nav-link">Register</span>
                  </Tab>
                </TabList>

                <div className="tab-content">
                  <TabPanel style={{ paddingTop: "2rem" }}>
                    <div>
                      <form action="#">
                        <div className="form-group">
                          <label htmlFor="singin-email-2">
                            Email address *
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="singin-email-2"
                            name="email"
                            value={loginForm.email}
                            onChange={handleInputChange}
                            required
                          />
                        </div>

                        <div className="form-group">
                          <label htmlFor="singin-password-2">Password *</label>
                          <input
                            type="password"
                            className="form-control"
                            id="singin-password-2"
                            name="password"
                            value={loginForm.password}
                            onChange={handleInputChange}
                            required
                          />
                        </div>

                        <div className="form-footer">
                          <button
                            onClick={OnLogin}
                            type="submit"
                            className="btn btn-outline-primary-2"
                          >
                            <span>LOG IN</span>
                            <i className="icon-long-arrow-right"></i>
                          </button>

                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="signin-remember-2"
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="signin-remember-2"
                            >
                              Remember Me
                            </label>
                          </div>

                          <a href="/resetPassword" className="forgot-link">
                            Forgot Your Password?
                          </a>
                        </div>
                      </form>
                      <div className="form-choice">
                        <p className="text-center">or sign in with</p>
                        <div className="row">
                          <div className="col-sm-6">
                            <a
                              href={`${process.env.REACT_APP_API_URL}/ecomm/api/v1/login/google`}
                              className="btn btn-login btn-g"
                            >
                              <i className="icon-google"></i>
                              Login With Google
                            </a>
                          </div>
                          <div className="col-sm-6">
                            <a
                              href={`${process.env.REACT_APP_API_URL}/ecomm/api/v1/login/facebook`}
                              className="btn btn-login btn-f"
                            >
                              <i className="icon-facebook-f"></i>
                              Login With Facebook
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>

                  <TabPanel>
                    <form onSubmit={(e) => OnSignup(e)}>
                      <div className="form-group">
                        <label htmlFor="register-username-2">Username *</label>
                        <input
                          type="text"
                          className="form-control"
                          id="register-username-2"
                          name="username"
                          value={loginForm.username}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="register-name-2">Name *</label>
                        <input
                          type="text"
                          className="form-control"
                          id="register-name-2"
                          name="name"
                          value={loginForm.name}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="register-email-2">
                          Your email address *
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="register-email-2"
                          name="email"
                          value={loginForm.email}
                          onChange={handleInputChange}
                          required
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="register-password-2">Password *</label>
                        <input
                          type="password"
                          className="form-control"
                          id="register-password-2"
                          name="password"
                          value={loginForm.password}
                          onChange={handleInputChange}
                          required
                        />
                      </div>

                      <div className="form-footer">
                        <button
                          type="submit"
                          className="btn btn-outline-primary-2"
                        >
                          <span>SIGN UP</span>
                          <i className="icon-long-arrow-right"></i>
                        </button>

                        <div className="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="register-policy-2"
                            required
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="register-policy-2"
                          >
                            I agree to the{" "}
                            <a href="/faq">privacy policy</a> *
                          </label>
                        </div>
                      </div>
                    </form>
                    <div className="form-choice">
                      <p className="text-center">or sign in with</p>
                      <div className="row">
                        <div className="col-sm-6">
                          <a
                            href={`${process.env.REACT_APP_API_URL}/ecomm/api/v1/login/google`}
                            className="btn btn-login btn-g"
                          >
                            <i className="icon-google"></i>
                            SignUp With Google
                          </a>
                        </div>
                        <div className="col-sm-6">
                          <a
                            href={`${process.env.REACT_APP_API_URL}/ecomm/api/v1/login/facebook`}
                            className="btn btn-login  btn-f"
                          >
                            <i className="icon-facebook-f"></i>
                            SignUp With Facebook
                          </a>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                </div>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(LoginOne);
